<template>
    <div class="consent-toggle">
        <div class="consent-toggle__text">
            <label
                :for="name"
                class="consent-toggle__label"
            >
                {{ $t(label) }}
            </label>
            <p
                v-if="description"
                class="consent-toggle__description"
            >
                {{ $t(description) }}
            </p>
        </div>
        <ToggleSwitch
            :modelValue="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
            :inputId="name"
            :name="name"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import ToggleSwitch from 'primevue/toggleswitch'

export default {
    name: 'ConsentToggle',

    components: { ToggleSwitch },

    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },

        name: {
            type: String,
            required: true,
        },

        label: {
            type: String,
            required: true,
        },

        description: {
            type: String,
            default: '',
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:modelValue'],
}
</script>

<style scoped>
.consent-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0;
}

.consent-toggle__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
}

.consent-toggle__label {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--text-dark, #040f0f);
    cursor: pointer;
}

.consent-toggle__description {
    margin: 0;
    font-size: 1.4rem;
    color: var(--text-dark-muted, var(--color-secondary-300));
    line-height: 1.4;
}

.consent-toggle :deep(.p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-slider) {
    background: var(--color-primary-700);
    border-color: var(--color-primary-700);
}

.consent-toggle :deep(.p-toggleswitch:not(.p-toggleswitch-checked) .p-toggleswitch-slider) {
    background: var(--color-neutral-700);
    border-color: var(--color-neutral-700);
}

.consent-toggle :deep(.p-toggleswitch.p-disabled.p-toggleswitch-checked .p-toggleswitch-slider) {
    background: var(--color-primary-700);
    border-color: var(--color-primary-700);
    opacity: 1;
}
</style>
